import axios from "axios";
import { API_END_POINT } from "../../../constants/api";

export function creatcompany(companyData) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  const body = JSON.stringify(companyData);
  let response = axios.post(`${API_END_POINT}/company/add`, body, config);

  return response;
}

export function getCompany(params) {
  let authToken = localStorage.getItem("usertoken");

  let { userId, limit } = params;
  console.log("authToken at get company call", authToken);
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  let response = axios.get(
    `${API_END_POINT}/company/get-company/user/${userId}${
      limit ? `/${limit}` : ""
    }`,
    config
  );
  return response;
}

export function getSpecificCompany(params) {
  console.log("params:::", params);
  let authToken = localStorage.getItem("usertoken");

  let { userId, companyId } = params;
  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  let response = axios.get(
    `${API_END_POINT}/company/get-company/user/${userId}/company/${companyId}`,
    config
  );
  return response;
}

export function deleteCompany(companyIdtoDelete) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  let response = axios.delete(
    `${API_END_POINT}/company/delete-company/${companyIdtoDelete}`,
    config
  );
  return response;
}

export function updateCompany(companyIdtoEdit, updatedData) {
  let authToken = localStorage.getItem("usertoken");

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authToken}`,
    },
  };
  const body = JSON.stringify(updatedData);
  let response = axios.put(
    `${API_END_POINT}/company/edit-company/${companyIdtoEdit}`,
    body,
    config
  );
  return response;
}
